export const BreadcrumbMap = {
    customer: '客户和业务',
    globalSearch: '全球搜索',
    addressBook: '联系人',
    customs: '海关数据',
    aisearch: '智能引擎搜索',
    linkedin: 'LinkedIn获客',
    cantonfair: '展会数据',
    lbs: 'LBS搜索',
    extension: '插件获客',
    ffms: '运价页面统计',
    template: '内容库',
    draft: '草稿列表',
    copyTask: '邮件任务列表',
    uniTemplate: '商品列表',
    br: '一带一路专题',
    newCreate: '智能营销',
    smartrcmd: '智能推荐',
    facebook: '上一级页面',
    customerRcmd: '上一级页面',
    default: '上一级页面',
    personalOrg: '通讯录',
    marketingModal: '智能营销',
    forwarder: '上一级页面',
    intelligent: '上一级页面',
    keywords: '上一级页面',
    innerContent: '智能营销',
    grub: '上一级页面',
    taskzhenduan: '诊断与建议',
    templateV2: '内容库',
    noviceTask: '新手任务',
    contomFair: '展会获客',
    copyPlan: '营销任务详情',
    contactPush: '联系人',
    innerContactPush: '联系人',
    manageContacts: '自动开发任务列表',
    sendMailFail: '',
    subscription: '',
    peers: '',
    crmdetail: '',
    mySite: '品牌建设',
    unknown: '',
    userPortrait: '用户画像',
    fission: '采供链裂变',
    peerBuyer: '同行采购商',
    tradingTransaction: '交易异动',
    developNewMarkets: '开拓新市场',
    deliverCenter: '营销效果统计',
    potentialMarketing: '潜客营销',
};
export var TaskChannel;
(function (TaskChannel) {
    TaskChannel["normal"] = "normal";
    TaskChannel["senderRotate"] = "senderRotate";
})(TaskChannel || (TaskChannel = {}));
export const defaultConfig = {
    maximumBytes: 300,
    minimumBytes: 30,
    sentenceCount: 4,
    wordsBlackList: [],
    hostingMaxVersion: 125,
};
export const DailyDetailTabs = ['SEND', 'REPLY', 'UNSUBSCRIBE'];
